import React from "react";
import { useTranslation } from "react-i18next";
import TransactionOverviewCards from "./TransactionOverviewCards";

export const getColor = (status) => {
  if (status === "rejected") return "error";
  if (status === "approved") return "success";
  if (status === "pending") return "info";
  if (status === "queued") return "warning";
  if (status === "complete") return "success";
  if (status === "error") return "error";
  if (status === "Abnormal Request") return "error";
  if (status === "not-required") return "warning";
  if (status === "active") return "success";
  return "secondary";
};

function formatDateTime(data) {
  if (!data) return null;
  const date = new Date(data);
  if (Number.isNaN(date.getTime())) return data;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

function ResponseDetailsComponentNew({ item }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  return (
    <div dir={isRTL ? "rtl" : "ltr"} className="space-y-2">
      {item?.validation_errors?.length > 0 && (
        <div className="rounded-md border border-yellow-300 bg-yellow-50 px-3 py-2">
          <div className="mb-1 text-[13px] font-bold uppercase tracking-tight text-yellow-700">
            {t("Validation Errors")}
          </div>
          {item.validation_errors.map((ve, veIdx) => (
            <div key={veIdx} className="mb-1">
              {ve.error_date && (
                <span className="text-[13px] font-semibold text-yellow-600">
                  {formatDateTime(ve.error_date)}
                </span>
              )}
              {ve?.errors?.map((err, errIdx) => (
                <div
                  key={errIdx}
                  className="flex items-start gap-1 py-0.5 text-[13px] leading-tight"
                >
                  <span className="whitespace-nowrap font-bold text-yellow-800">
                    {err.error_code}:
                  </span>
                  <span className="text-yellow-700">{err.error_message}</span>
                  {err.value_string && (
                    <span className="break-all text-[13px] font-medium text-yellow-600">
                      ({err.value_string})
                    </span>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      <TransactionOverviewCards item={item} mode="preauth" />
    </div>
  );
}

export default ResponseDetailsComponentNew;
